import React from 'react';
import { _cs } from '@togglecorp/fujs';
import Svg from '../Svg/index.js';
import { genericMemo } from '../../utils/index.js';
import ballonSvg from './images/ballon.svg.js';
import hiSvg from './images/hi.svg.js';
import workSvg from './images/work.svg.js';
import exerciseSvg from './images/exercise.svg.js';
import experimentSvg from './images/experiment.svg.js';
import searchSvg from './images/search.svg.js';
import skydiveSvg from './images/skydive.svg.js';
import coffeeSvg from './images/coffee.svg.js';
import fatSvg from './images/fat.svg.js';
import moveSvg from './images/move.svg.js';
import readSvg from './images/read.svg.js';
import singSvg from './images/sing.svg.js';
import skateSvg from './images/skate.svg.js';
import sleepSvg from './images/sleep.svg.js';
import standbySvg from './images/standby.svg.js';
import whipSvg from './images/whip.svg.js';
import crutchesSvg from './images/crutches.svg.js';
import icecreamSvg from './images/icecream.svg.js';
import styles from './styles.css.js';

const sizeToStyleMap = {
  extraSmall: styles.extraSmall,
  small: styles.small,
  medium: styles.medium,
  large: styles.large,
  extraLarge: styles.extraLarge
};
const variantToSvgMap = {
  ballon: ballonSvg,
  exercise: exerciseSvg,
  experiment: experimentSvg,
  search: searchSvg,
  skydive: skydiveSvg,
  work: workSvg,
  coffee: coffeeSvg,
  fat: fatSvg,
  move: moveSvg,
  read: readSvg,
  sing: singSvg,
  skate: skateSvg,
  sleep: sleepSvg,
  standby: standbySvg,
  whip: whipSvg,
  hi: hiSvg,
  crutches: crutchesSvg,
  icecream: icecreamSvg
};

function Kraken(props) {
  const {
    className,
    variant = 'hi',
    size = 'small'
  } = props;
  return /*#__PURE__*/React.createElement(Svg, {
    className: _cs(className, styles.kraken, sizeToStyleMap[size]),
    src: variantToSvgMap[variant]
  });
}

var Kraken$1 = genericMemo(Kraken);

export { Kraken$1 as default };
//# sourceMappingURL=index.js.map
